export function encodeMediaUrl(url: string): string {
    return encodeURI(url).replace(/'/, '%27')
}

export default {
    encodeMediaUrl
}